import { setEditingTextId, style, useTool } from '../editor.ts'
import { createText } from '../scene/factory.ts'
import { beginCommit, insertNodes, scene, select } from '../scene/store.ts'
import type { Tool } from './types.ts'

export const textTool: Tool = {
  cursor: 'text',

  onPointerDown(ctx) {
    // Clicking an existing text node edits it rather than stacking a new one.
    const hit = ctx.nodeId ? scene.nodes[ctx.nodeId] : undefined
    if (hit?.type === 'text' && !hit.locked) {
      select([hit.id])
      setEditingTextId(hit.id)
      useTool('select')
      return
    }

    const node = {
      ...createText(ctx.world),
      color: style.textColor,
      fontSize: style.fontSize,
    }

    // Creating and typing are one undo step: the commit opens here and the text
    // editor closes it on blur. A node left empty cancels out to no entry at all.
    beginCommit([node.id], true)
    insertNodes([node])
    select([node.id])
    setEditingTextId(node.id)
    useTool('select')
  },
}
